import { useMutation } from "@tanstack/vue-query"
import { axios } from "@/axios"

export interface IUpgradeForm {
  guestsNo: string
  isMultiDay: boolean
  otherInfo?: string
}

export interface IUpgradeRequest {
  NumberOfGuests: string
  IsMultiDayEvent: boolean
  OtherInfo?: string
}

/**
 * Creates an event upgrade request to the server.
 */
export async function createUpgradeRequest(upgradeForm: IUpgradeForm, eventVaultId: number) {
  const upgradeRequest: IUpgradeRequest = {
    NumberOfGuests: upgradeForm.guestsNo,
    IsMultiDayEvent: upgradeForm.isMultiDay,
    OtherInfo: upgradeForm.otherInfo,
  }

  const response = await axios.post(`/api/event/${eventVaultId}/upgrades/contactus`, upgradeRequest)

  return response.data?.Message
}

const CREATE_UPGRADE_REQUEST_KEY = "createUpgradeRequest"

export function useCreateUpgradeRequest() {
  return useMutation({
    mutationKey: [CREATE_UPGRADE_REQUEST_KEY],
    mutationFn: ({ upgradeRequest, eventVaultId }: { upgradeRequest: IUpgradeForm, eventVaultId: number }) => createUpgradeRequest(upgradeRequest, eventVaultId),
  })
}
